import Vue from 'vue'
import VueRouter from 'vue-router'
import store from './../store'
import api from './../api'
import conf from './../config/url'
Vue.use(VueRouter)

const routes = [
	{
		name: 'entrance',
		path: '/entrance',
		redirect: { name: 'login' },
		meta: { title: '入口', icon: '', show: false, roles: [] },
		component: () => import(/* webpackChunkName: 'mainEntrance' */ '../views/entrance'),
		children: [
			{
				name: 'login',
				path: 'login',
				meta: { title: '登录', icon: '', show: false, roles: [] },
				component: () => import(/* webpackChunkName: 'mainEntrance' */ '../views/entrance/login.vue'),
			},
			{
				name: 'register',
				path: 'register',
				meta: { title: '企业注册', icon: '', show: false, roles: [] },
				component: () => import(/* webpackChunkName: 'mainEntrance' */ '../views/entrance/signIn.vue'),
			},
			{
				name: 'forget',
				path: 'forget',
				meta: { title: '重置密码', icon: '', show: false, roles: [] },
				component: () => import(/* webpackChunkName: 'mainEntrance' */ '../views/entrance/forget.vue'),
			},
			{
				name: 'organ',
				path: 'organ',
				meta: { title: '组织', icon: '', show: false, roles: [] },
				component: () => import(/* webpackChunkName: 'mainEntrance' */ '../views/entrance/organ.vue'),
			},
      {
        name: 'slhSignIn',
        path: 'slhSignIn',
        meta: { title: '商联会注册', icon: '', show: false, roles: [] },
        component: () => import(/* webpackChunkName: 'mainEntrance' */ '../views/entrance/slhSignIn.vue')
      }
		],
	},
	{
		name: 'entrance_new',
		path: '/entrance_new',
		redirect: { name: 'login' },
		meta: { title: '入口', icon: '', show: false, roles: [] },
		component: () => import(/* webpackChunkName: 'mainEntrance' */ '../views/entrance'),
		children: [
			{
				name: 'login',
				path: 'login',
				meta: { title: '登录', icon: '', show: false, roles: [] },
				component: () => import(/* webpackChunkName: 'mainEntrance' */ '../views/entrance_new/login.vue'),
			},
			{
				name: 'forget',
				path: 'forget',
				meta: { title: '重置密码', icon: '', show: false, roles: [] },
				component: () => import(/* webpackChunkName: 'mainEntrance' */ '../views/entrance_new/forget.vue'),
			},
		],
	},
	{
		name: 'personal',
		path: '/personal',
		meta: { title: '个人中心', icon: '', show: false, roles: [] },
		component: () => import(/* webpackChunkName: 'personal' */ '../views/personal'),
	}
]

const router = new VueRouter({
	mode: 'history',
	routes,
	scrollBehavior(to, from) {
		return { x: 0, y: 0 };
	}
})

const forMenu = (el, arr) => {
	const { data, children } = el
	arr = [
		...arr,
		{
			path: `/${data.systemTagName}${data.url}`,
			title: data.name,
			type: data.type,
		},
	]
	el.path = `/${data.systemTagName}${data.url}`
	el.matched = arr
	if (children && children.length) {
		children.forEach((item) => {
			forMenu(item, arr)
		})
	}
}

let isNewSaasConfig, isNewSaas
let isFirst = true //第一次获取配置标识
router.beforeEach(async (to, from, next) => {
	store.state.currentRouter = to.path
    console.log('router-----to------------',to)
	if(["/custom/certificateQueryPage","/custom/certificateQueryResult"].includes(to.path)){
		await next();
		return;
	}

	window.addEventListener('popstate', () => {
		if (from.path == 'entrance/organ') {
			return false
		}
	})


	// 一键实施默认登录(演示用)
	await demoLogin(to)

	// 是否用户中心改造
	if (isFirst && !isNewSaasConfig) {
		let  frontendConfig = sessionStorage.getItem('frontendConfig') && JSON.parse(sessionStorage.getItem('frontendConfig'))||[];

		// console.error('router=frontendConfig==',sessionStorage.getItem('frontendConfig'))
		// await api.configuration.getConfigurationNew().then((res) => {
		isNewSaasConfig =  frontendConfig.find((item) => item.key === 'isNewSaas')
		// console.log('first----------------------------', store.state.dynamic.frontendConfig, isNewSaasConfig)
		isFirst = false
		if (isNewSaasConfig) {
			if (isNewSaasConfig.value === 'true') {
				isNewSaas = true
				store.commit('setSaasFlag', true)
			}
		}
		// })
	}



	// if (isFirst && !isNewSaasConfig) {
	// 	await api.configuration.getConfiguration(conf.confUrl).then((res) => {
	// 		if (res.success) {
	// 			isNewSaasConfig = res.data.frontendConfig.find((item) => item.key === 'isNewSaas')
	// 			// console.log('first----------------------------', store.state.dynamic.frontendConfig, isNewSaasConfig)
	// 			isFirst = false
	// 			if (isNewSaasConfig) {
	// 				if (isNewSaasConfig.value === 'true') {
	// 					isNewSaas = true
	// 					store.commit('setSaasFlag', true)
	// 				}
	// 			}
	// 		}
	// 	})
	// }
	// isNewSaas = true
	// store.commit('setSaasFlag', true)

	if (
		!localStorage.getItem('token') &&
		![
			'/entrance/login',
			'/entrance_new/login',
			'/entrance',
			'/entrance/register',
			'/entrance_new/register',
			'/entrance/forget',
			'/entrance_new/forget',
			'/saas/screen/governmentDataScreen',
			'/saas/screen/trainRegulation',
			'/entrance/slhSignIn',
			'/custom/certificateQueryPage',
			'/custom/certificateQueryResult',
			'/personal'
		].includes(to.path)
	) {
		if (isNewSaas) {
			//用户中心改造标识
			await next({ path: '/entrance_new/login' })
		} else {
			await next({ path: '/entrance/login' })
		}
	} else if (localStorage.getItem('token') && !localStorage.getItem('branchList')) {
		//选择管理员管理的机构
		if (isNewSaas) {
			await api.branch_new.getFindAdminBranchList({}).then(async (res) => {
				if (res.data && res.data[0]) {
					localStorage.setItem('branchName', res.data[0].name)
					localStorage.setItem('branchUcode', res.data[0].ucode)
					localStorage.setItem('branchList', JSON.stringify(res.data))
					await api.account_new.switchBranch({ branchUcode: res.data[0].ucode })
				}
			})
		} else {
			await api.operate.getFindAdminBranchList({}).then((res) => {
				if (res.data && res.data[0]) {
					localStorage.setItem('branch', res.data[0].branch || null)
					localStorage.setItem('organ', res.data[0].organ || null)
					localStorage.setItem('actor', res.data[0].actor || null)
					res.data[0].channel && localStorage.setItem('channel', res.data[0].channel)
					localStorage.setItem('branchList', JSON.stringify(res.data))

					sessionStorage.setItem('branch', res.data[0].branch || null)
					sessionStorage.setItem('organ', res.data[0].organ || null)
					sessionStorage.setItem('actor', res.data[0].actor || null)
					res.data[0].channel && sessionStorage.setItem('channel', res.data[0].channel)
					sessionStorage.setItem('branchList', JSON.stringify(res.data))
				}
			})
		}
	}
	if (
		localStorage.getItem('token') &&
		![
			'/entrance/login',
			'/entrance_new/login',
			'/entrance',
			'/entrance/register',
			'/entrance_new/register',
			'/entrance/forget',
			'/entrance_new/forget',
      		'/entrance/slhSignIn',
		].includes(to.path)
	) {
		const hostname = window.location.hostname
		if (isNewSaas) {
			!store.state.nav.length &&
				(await api.permission_new.getUserMenu({}).then((res) => {
					if (res.data && res.data.length && hostname.includes('jiazheng')) {
						res.data.unshift({
							data: {
								systemTagName: 'saas',
								url: '/jiazheng',
								description: '使用帮助',
								name: '使用帮助',
								type: 2,
							},
							name: '使用帮助',
							children: null,
							parentId: 0,
						})
					}
					res.data.forEach((item) => {
						forMenu(item, [])
					})
					store.state.nav = res.data || []
				}))
		} else {
			!store.state.nav.length &&
				(await api.role.getUserMenu({}).then((res) => {
					if (res.data && res.data.length && hostname.includes('jiazheng')) {
						res.data.unshift({
							data: {
								systemTagName: 'saas',
								url: '/jiazheng',
								description: '使用帮助',
								name: '使用帮助',
								type: 2,
							},
							name: '使用帮助',
							children: null,
							parentId: 0,
						})
					}
					res.data.forEach((item) => {
						forMenu(item, [])
					})
					store.state.nav = res.data || []
				}))
		}

		if (to.path === '/' && store.state.nav[0]) {
			let path = ''
			if (store.state.nav[0].children && store.state.nav[0].children.length) {
				path = store.state.nav[0].children[0].path
			} else {
				path = store.state.nav[0].path
			}
			await next(path)
		}
    }
    // 用户改造
    if(to.path === '/entrance/login' && isNewSaas){
        next('/entrance_new/login')
    }
	await next()
})

router.afterEach(() => {
	window.scrollTo(0, 0);
	 if(document.getElementById("appContainer")){ //内容区块滚动到最顶部
            // document.getElementById("wdc-app").scrollIntoView();
            document.getElementById("appContainer").scrollTo(0,0);
        }
})

async function demoLogin(to) {
	if (to.path === '/saas/demo_homepage') {
		if (!localStorage.getItem('token')) {
			localStorage.setItem('isWdDemo', 1) //是否是一键实施demo
			await api.operate.demoLogin({ adminFlag: 1 }).then((res) => {
				if (res.data) {
					localStorage.setItem('token', res.data)
					sessionStorage.setItem('token', res.data)
				}
			})
			await api.operate.getFindOrganList({}).then((res) => {
				if (res.data && res.data[0]) {
					localStorage.setItem('organ', res.data[0].organ || null)
					localStorage.setItem('actor', res.data[0].actor || null)
					res.data[0].channel && localStorage.setItem('channel', res.data[0].channel)

					sessionStorage.setItem('organ', res.data[0].organ || null)
					sessionStorage.setItem('actor', res.data[0].actor || null)
					res.data[0].channel && sessionStorage.setItem('channel', res.data[0].channel)
				}
			})
			await api.operate.getFindAdminBranchList({}).then((res) => {
				if (res.data && res.data[0]) {
					localStorage.setItem('branch', res.data[0].branch || null)
					localStorage.setItem('organ', res.data[0].organ || null)
					localStorage.setItem('actor', res.data[0].actor || null)
					res.data[0].channel && localStorage.setItem('channel', res.data[0].channel)
					localStorage.setItem('branchList', JSON.stringify(res.data))

					sessionStorage.setItem('branch', res.data[0].branch || null)
					sessionStorage.setItem('organ', res.data[0].organ || null)
					sessionStorage.setItem('actor', res.data[0].actor || null)
					res.data[0].channel && sessionStorage.setItem('channel', res.data[0].channel)
					sessionStorage.setItem('branchList', JSON.stringify(res.data))
				}
			})
		}
	}
}

export default router
